(function($) {

    let couponNumber = 1;

    window.positioningVineGlasses = function() {
        let container = $('.section-coupon-create .container-content');

        if (container.length > 0) {
            let offset = container.offset();
            let bgLeft = offset.left + container.width() - 95;

            $('.bg-vine-glasses').css('background-position-x', bgLeft + 'px');
        }
    }

    window.cloneCoupon = function(number) {
        let template = $('.coupon-template');

        if (template.length > 0) {
            let templateContent = template.html().replace(/%NUMBER%/g, number);

            $('.coupons').append(templateContent);

            if (number === 1) {
                $('.coupon-1').find('.btn-delete-coupon').remove();
            }
        }
    }

    $(window).on('load', function() {
        positioningVineGlasses();
        cloneCoupon(couponNumber);
    });

    $(window).on('resize', function() {
        positioningVineGlasses();
    });

    $(document).on('click', '.coupon-type-radio', function() {
        let container = $(this).closest('.coupon');
        let value = $(this).val();

        container.find('.coupon-type').addClass('d-none');
        container.find('.coupon-type-' + value).removeClass('d-none');
    });

    $(document).on('click', '.btn-add-coupon', function() {
        couponNumber++;

        cloneCoupon(couponNumber);
    });

    $(document).on('click', '.btn-delete-coupon', function() {
        $(this).closest('.form-group').remove();
    });

    $(document).on('change keyup blur focus', '.character-count', function() {
        let value = $(this).val();
        let maxLength = parseInt($(this).data('max'));
        let infoContainer = $(this).parent().find('.info');

        if (value.length > maxLength) {
            value = value.substring(0, maxLength);

            $(this).val(value);
        }

        infoContainer.html(value.length + '/' + maxLength + ' karakter');
    });

    $('.opening-hour-select').SumoSelect();

    $(document).on('change', '.opening-hour-select', function() {
        if ($(this).val() === 'closed') {
            let pair = $('#' + $(this).data('pair'));

            if (pair.val() !== 'closed') {
                pair[0].sumo.selectItem('closed');
            }
        }
    });

    $(document).on('ajaxSuccess', '#form-winery-create', function() {
        document.getElementById('form-winery-create').reset();

        $('.custom-file-upload .before').removeClass('d-none');
        $('.custom-file-upload .after').addClass('d-none');

        Swal.fire({
            title: 'Borászat rögzítve!',
            icon: 'success',
            confirmButtonText: 'Bezár'
        });
    });

    $(document).on('ajaxError', '#form-winery-create', function() {
        let inputPosition = $('.has-error').first().offset();

        $('html, body').animate({
            scrollTop: inputPosition.top - 50
        });
    });

})(jQuery);
